<template>
  <div role="radiogroup" :class="[baseCss, block ? ['block', 'w-full'] : ['inline-block', 'align-middle'], vertical ? `${baseCss}-vertical` : null, 'select-none', disabled ? ['disabled', 'pointer-events-none'] : null]">
    <ul :class="['barebone-list', vertical ? null : ['inline-list', noWrap ? 'whitespace-nowrap' : null]]">
      <slot />
    </ul>
  </div>
</template>
<script>
import methods from '../../mixins/methods'
import props from '../../mixins/props'

export default {
  name: 'RadioGroup',
  mixins: [
    props,
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('radio-group', [])
    }
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    checked: null,
    disabled: {
      type: Boolean
    },
    name: {
      type: String,
      required: true
    },
    vertical: {
      type: Boolean,
      default: true
    },
    block: {
      type: Boolean,
      default: true
    },
    noWrap: {
      type: Boolean,
      default: true
    },
    noWrapLabel: {
      type: Boolean,
      default: true
    },
    truncateLabel: {
      type: Boolean
    },
    yAlign: {
      type: String,
      default: 'middle',
      validator: value => {
        return ['top', 'middle', 'bottom', 'baseline', 'auto'].includes(value)
      }
    },
    iconChecked: {
      type: String,
      default: 'radiobox-marked'
    },
    iconBlank: {
      type: String,
      default: 'radiobox-blank'
    },
    iconSize: {
      type: Number,
      default: 1.5
    },
    labelSize: {
      type: String,
      default: 'sm',
      validator: value => {
        return ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
      }
    }
  }
}
</script>
<style>
.bcq-radio .bcq-icon
{
  display: none;
}

.bcq-radio input:checked ~ .bcq-radio-icon-checked,
.bcq-radio input:not(:checked) ~ .bcq-radio-icon-blank
{
  display: inline-block;
}

.bcq-radio label .bcq-radio-label
{
  max-width: 85%;
}
</style>



// WEBPACK FOOTER //
// src/bcq-ui/components/radio-group/radio-group.vue